import defaultClient from '@cube3/state/src/wrapped-cube-client/wrapped-cube-client';
import { useCallback, useMemo, useState } from 'react';
import { getEnvVar } from '../../../../../utils/getEnvVar';



interface Config {
  isMenuOpen?: boolean;
  toggle?(): void;
  sameWindow?: boolean;
}

export const useOpenDocs = ({
  isMenuOpen,
  toggle,
  sameWindow
}: Config = {}) => {
  const [docsAuthError, setDocsAuthError] = useState(null);

  const DOCS_URL = useMemo(() => getEnvVar('DOCS_URL'), []);
  const DOCS_AUTH = useMemo(() => getEnvVar('DOCS_AUTH') === 'true', []);

  const handleOpenDocs = useCallback(
    (path = '') => {
      if (DOCS_AUTH) {
        defaultClient.auth
          .request({ method: 'POST', url: '/auth/tokens/user-guide' })
          .then((res) => {
            const t = res.data.access_token;
            return fetch(DOCS_URL + path, {
              headers: {
                Authorization: `cube2 ${res.data.access_token}`,
                origin: window.location.origin
              },
              credentials: 'include'
            }).then((res) => {
              window.open(
                DOCS_URL + path,
                sameWindow ? '_self' : '_blank',
                'noreferrer noopener'
              );
              if (isMenuOpen) {
                toggle?.();
              }
            });
          })
          .catch((e) => {
            setDocsAuthError(e);
          });
      } else {
        window.open(
          DOCS_URL + path,
          sameWindow ? '_self' : '_blank',
          'noreferrer noopener'
        );
        if (isMenuOpen) {
          toggle?.();
        }
      }
    },
    [toggle, isMenuOpen, setDocsAuthError]
  );

  return { handleOpenDocs, hasDocs: DOCS_URL, docsAuthError };
};
